import React from 'react';
import AppStateProvider, { useAppState } from '../../../src/state';
import { AVCheck } from './AVCheck';
import generateConnectionOptions from '../../../src/utils/generateConnectionOptions/generateConnectionOptions';
const AlucioAVCheck = (props) => {
    const { children, meetingName, attendeeName, onJoinMeeting, isMobile, deniedMediaImage, audioFiles, submitLabel, showDisclaimer, } = props;
    const { setError, settings } = useAppState();
    const connectionOptions = generateConnectionOptions(settings);
    return (React.createElement(AVCheck, { options: connectionOptions, onError: setError, meetingName: meetingName, attendeeName: attendeeName !== null && attendeeName !== void 0 ? attendeeName : '', onJoinMeeting: onJoinMeeting, mobileView: isMobile, deniedMediaImage: deniedMediaImage, audioFiles: audioFiles, submitLabel: submitLabel, showDisclaimer: showDisclaimer }, children));
};
const WithAppState = (Component) => (props) => {
    return (
    /* maxTracks we need one additional spot because when the app is in sharing mode, a track is taken for sharing screen
      id we don't do this one of the participants will get freeze
    */
    React.createElement(AppStateProvider, null,
        React.createElement(Component, Object.assign({}, props))));
};
export default WithAppState(AlucioAVCheck);
//# sourceMappingURL=AlucioAVCheck.js.map